import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { PropertyDetailPage } from './pages/PropertyDetailPage';
import { CategoryPage } from './pages/CategoryPage';
import { ContactPage } from './pages/ContactPage';
import  PolicyPage  from './pages/PolicyPage';
import { LonavalaPage } from './pages/LonavalaPage';
import { LonavalaThankYouPage } from './pages/LonavalaThankYouPage';


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/properties" element={<PropertiesPage />} />
            <Route path="/properties/:slug" element={<PropertyDetailPage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/lonavala" element={<LonavalaPage />} />
            <Route path="/lonavala/thank-you" element={<LonavalaThankYouPage />} />
            <Route path="/policy/:slug" element={<PolicyPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
